import React, { Component } from 'react';
import requireCapability from './component/permissions/requireCapability';
import { loadAccess } from './component/permissions/access';
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
// import axios from 'axios';
import { createBrowserHistory } from 'history';
import { installNavTrail } from './_utils/navTrail';

import {PrivateRoute} from "./routing/PrivateRoute";
import { BookingInDiaryRedirect, NewBookingRedirect } from "./routing/LegacyRedirects";
import { userActions } from "./_actions";
import { userService } from "./_services";
import SubscriptionCheckout from "./component/auth/SubscriptionCheckout";
import PartnerTermsWelcome from "./component/auth/PartnerTermsWelcome";
import { Capacitor } from '@capacitor/core';
import UniversalSearch from './component/shared/UniversalSearch';
import MobileTabBar from './component/common/MobileTabBar';
import StampEarnedCelebration from './component/wallet/StampEarnedCelebration';
import NewBookingHost from './component/DiaryV2/NewBookingHost';
import { OnboardingProvider } from './component/onboarding/ImportJobContext';
import OnboardingHost from './component/onboarding/OnboardingHost';
import { SetupProvider } from './component/onboarding/setup/SetupContext';
import SetupHost from './component/onboarding/setup/SetupHost';
import StripeAlertHost from './component/settings/StripeAlertHost';
import OnboardingPreview from './component/onboarding/OnboardingPreview';
import ReceptionModeGuard from "./component/common/ReceptionModeGuard";
import SideNav from "./component/template/SideNav";
import "./legacyPageStyles";
import Pagenotfound           from "./component/template/Pagenotfound";
import ResetPassword          from "./component/auth/ResetPassword";
import Homepage               from "./component/home/NewHomePage";
// import NewBooking             from "./component/hairdresserBooking/NewBooking";
import NewEvent             from "./component/hairdresserEvent/NewEvent";
import Leave              from "./component/leave/Leave";
import InstantCheckout             from "./component/checkoutBooking/InstantCheckout";
import POSPage                     from "./component/pos/POSPage";
import Clients                from "./component/clients/Clients";
import DataSharing            from "./component/clients/DataSharing";
import Ownership              from "./component/clients/Ownership";
import ExportImport           from "./component/clients/ExportImport";
import ClientsMobileNav       from "./component/clients/ClientsMobileNav";

import Finance                from "./component/finance";
import FinanceMobileNav       from "./component/finance/FinanceMobileNav";

import './App.css';
import './component/newSalon/salon.css'
import AddClient from './component/clients/AddClient';
import EditClient from './component/clients/EditClient';
import Staff from './component/staff/Staff';
import AddStaff from './component/staff/AddStaff';
import EditStaff from './component/staff/EditStaff';
import StaffMobileNav from './component/staff/StaffMobileNav';
import NewServices from './component/new-service/NewServices';

import AddServices from './component/new-service/add-edit-service/AddService';
import EditServices from './component/new-service/add-edit-service/EditService';

import SalonSettings from './component/settings/SalonSettings';
import EditPassword from './component/settings/EditPassword';
import ImportData from './component/settings/ImportData';
import OnboardingSettings from './component/settings/OnboardingSettings';
import DiaryDemoSettings from './component/settings/DiaryDemoSettings';
import BaileyWelcomeReplay from './component/onboarding/bailey-intro/BaileyWelcomeReplay';
import BaileyPet from './component/onboarding/bailey-intro/BaileyPet';
import FinishSetupSettings from './component/settings/FinishSetupSettings';

import EditBankAccount from './component/settings/EditBankAccount';
import Cashup from './component/cashup/Cashup';
import CashupDetail from './component/cashup-detail/CashupDetail';
import Stocktake from './component/stocktake/Stocktake';
import NewStocktake from './component/stocktake/NewStocktake';
import StocktakeDetail from './component/stocktake/StocktakeDetail';
import StockTransfersPage from './component/multiLocation/StockTransfersPage';
import CatalogueOverview from './component/catalogue/CatalogueOverview';
import Forms from './component/forms/Forms';
import NewForm from './component/forms/NewForm';
import FormSettings from './component/forms/FormSettings';
import FormSubmissionView from './component/forms/FormSubmissionView';
import FormComplete from './component/forms/FormComplete';
import FormFill from './component/forms/FormFill';
import GoThroughModalAfterLogin from './component/hairdresserAuth/GoThroughModalAfterLogin';
import Steps from './component/hairdresserAuth/Steps';

// New Auth Components
import Login from './component/auth/Login';
import SignupRoleSelector from './component/auth/SignupRoleSelector';
import ClientSignup from './component/auth/ClientSignup';
import ProfessionalSignup from './component/auth/ProfessionalSignup';
import ForgotPassword from './component/auth/ForgotPassword';
import AppleRedirect from './component/auth/AppleRedirect';
import BookingInvoice from './component/Invoice/Booking'
// import HairdressersHome from './component/hairdresserBooking/HairdressersHome';
// import JoinForFree from './component/hairdresserAuth/JoinForFree';
// import AcountSettings from './component/settings/AcountSettings';
import ComingSoon from './component/ComingSoon';
// import DiaryPage from './component/Diary/DiaryPage';
import DiaryV2 from './component/DiaryV2/DiaryV2';
// import Booking from './component/booking/Booking';
import Event from './component/events/Event';
import ClearCache from "react-clear-cache";
// import EditBooking from "./component/bookingEdit/EditBooking";

// import checkoutBooking from "./component/checkoutBooking/checkoutBooking";

import WebHeader from "./component/template/webHeader";
import Home from "./component/webHome/Home";
import Redirection from "./component/webHome/Redirection";
import Payment from "./component/payment/payment";
import PaymentSuccess from "./component/payment/PaymentSuccess";
// import NewDiary1 from "./component/Diary/NewDiary1";
// import DiaryResource from "./component/Diary/DiaryResource";
import BookingUrl from './component/settings/BookingUrl';
import NotificationSettings from './component/settings/NotificationSettings';
import AdminPolicies from './component/admin/AdminPolicies';
import AdminDeals from './component/admin/AdminDeals';
import { PartnerTermsPage, BeuPayTermsPage, ClientTermsPage, PrivacyPolicyPage } from './component/policy/PolicyPage';
// import SettingSidebar from './component/settings/SettingSidebar';
import PayoutAccount from './component/settings/PayoutAccount';
import CardReader from './component/settings/CardReaders';
import AddPayoutAccount from './component/settings/AddPayoutAccount';
import SettingMobileView from './component/settings';
import Product from './component/product/Product'
import AddProduct from './component/product/AddProduct'
import EditProduct from './component/product/EditProduct'
import DeleteProduct from './component/product/DeleteProduct'
import ViewProduct from './component/product/ViewProduct'
// import ProductCheckout from './component/product/ProductCheckout'
import SelectClient from './component/clients/SelectClient';
import SelectProduct from './component/product/SelectProduct';
import SelectVoucher from './component/checkoutBooking/SelectVoucher';
// import SelectService from './component/services/SelectService';
import NewSelectService from './component/services/NewSelectService';
import GiftCardsV2 from './component/gift-cards-v2/GiftCardsV2';
import SalonProfilePage from './component/newSalon/SalonProfilePage';
import GiftCardShop from './component/giftcard-shop/GiftCardShop';
import ProductShop from './component/product-shop/ProductShop';
import GiftCardConfirmation from './component/giftcard-shop/GiftCardConfirmation';
import ClaimGiftCard from './component/wallet/ClaimGiftCard';
import GiftCardEmailPreview from './component/giftcard-shop/GiftCardEmailPreview';
import BookingConfirmationPage from './component/newSalon/SalonProfilePage/BookingConfirmationPage';
import ProductOrderSuccess from './component/product-shop/ProductOrderSuccess';
import ServiceMobileView from './component/new-service/index';
import Marketing from './component/marketing/marketing';
import MarketingMobileView from './component/marketing';
import MarketingSettings from './component/marketing/settings';
import MarketingBrand from './component/marketing/brand/MarketingBrand';
import Billing from './component/settings/Billing';
import AiAssistant from './component/settings/AiAssistant';
import BusinessNumbers from './component/settings/BusinessNumbers';
import ReceptionInbox from './component/receptionist/ReceptionInbox';
import LocationsPage from './component/multiLocation/LocationsPage';
import DiarySharePage from './component/settings/DiarySharePage';
import ReceptionMode from './component/settings/ReceptionMode';
import YourChoices from './component/settings/YourChoices';
import MarketingCampaigns from './component/marketing/campaigns/MarketingCampaigns';
import CampaignStudioPage from './component/marketing-v2/features/campaigns/studio/CampaignStudioPage';
import MarketingPerformance from './component/marketing/campaigns/MarketingPerformance';
import MarketingJourneys from './component/marketing/journeys/MarketingJourneys';
import MarketingSocial from './component/marketing/social/MarketingSocial';
import MarketingHome from './component/marketing/home/MarketingHome';
import MarketingCalendarPage from './component/marketing/calendar/MarketingCalendarPage';
import AgentThread from './component/agent/AgentThread';
import { AGENT_VISIBLE, CONCIERGE_VISIBLE, PRICING_V2_VISIBLE, MESSAGES_VISIBLE } from './config/featureFlags';
import PricingHost from './component/pricing/PricingHost';
import TaxesPage from './component/taxes/TaxesPage';
import { TAXES_VISIBLE, ONBOARDING_DEMO_VISIBLE, SAVINGS_CALCULATOR_VISIBLE, DISCOUNTS_VISIBLE } from './config/featureFlags';
import LoyaltyPage from './component/loyalty-v2/LoyaltyPage';
import DiscountsPage from './component/discounts/DiscountsPage';
import ClientDashboard from './component/clientDashboard/ClientDashboard';
import ResourcesPage from './component/resources/ResourcesPage';

// Browse / Category Landing Pages
import CategoryLocationPage from './component/browse/CategoryLocationPage';

// Admin Components
import AdminDashboard from './component/admin/AdminDashboard';
import AdminSupportDesk from './component/admin/support/AdminSupportDesk';
import AdminUsers from './component/admin/AdminUsers';
import AdminUserDetail from './component/admin/AdminUserDetail';
import AdminProfessionals from './component/admin/AdminProfessionals';
import AdminProfessionalDetail from './component/admin/AdminProfessionalDetail';
import AdminBusinesses from './component/admin/AdminBusinesses';
import AdminBusinessDetail from './component/admin/AdminBusinessDetail';
import AdminBookings from './component/admin/AdminBookings';
import AdminBookingDetail from './component/admin/AdminBookingDetail';
import AdminFinancials from './component/admin/AdminFinancials';
import AdminReconciliations from './component/admin/AdminReconciliations';
import AdminPaymentBible from './component/admin/AdminPaymentBible';
import AdminMerchantApprovals from './component/admin/AdminMerchantApprovals';
import Bailey from './component/admin/Bailey';
import AdminAiOverview from './component/admin/ai/AdminAiOverview';
import AdminAiSalon from './component/admin/ai/AdminAiSalon';
import AdminAiSession from './component/admin/ai/AdminAiSession';

// Salon Sales Engine: beside the admin, not inside it. Lazy-loaded so the
// whole sales module (board, map, insights) stays out of the main bundle.
const SalesModuleChunk = React.lazy(() => import('./component/sales/SalesModule'));
const SalesModuleHost = (props) => (
    <React.Suspense fallback={<div style={{ minHeight: '100vh', background: '#f6f7f8' }} />}>
        <SalesModuleChunk {...props} />
    </React.Suspense>
);

// The stand savings calculator (staging only). Lazy, so the sales tool's
// pricing tables it reads stay out of the main bundle.
const SavingsCalculatorChunk = React.lazy(() => import('./component/settings/savingsCalculator/SavingsCalculatorSettings'));
const SavingsCalculatorHost = (props) => (
    <React.Suspense fallback={<div style={{ minHeight: '100vh', background: '#f6f7f8' }} />}>
        <SavingsCalculatorChunk {...props} />
    </React.Suspense>
);

// Beu Messages (MESSAGES_VISIBLE): team chat, then client chat and Beu
// Support. Lazy, so chat stays out of the main bundle until it is opened.
const MessagesChunk = React.lazy(() => import('./component/messages/MessagesPage'));
const MessagesHost = (props) => (
    <React.Suspense fallback={<div style={{ minHeight: '100vh', background: '#F6F6F8' }} />}>
        <MessagesChunk {...props} />
    </React.Suspense>
);

// The AI Assistant lives in the Bailey tab now, as Bailey's front desk.
// It says whether it came from inside Beu, so the front desk's back returns there.
const FrontDeskRedirect = (props) => <Redirect to={{ pathname: '/assistant/front-desk', state: { inApp: !!(props.history && props.history.action === 'PUSH') } }} />;

// Adding a location: Bailey's location track and its plan page. Lazy, like
// the sales module, and hoisted so the guarded components keep one identity
// across renders. Same owner guard as /settings/locations.
const AddLocationFlowChunk = React.lazy(() => import('./component/multiLocation/addLocation/AddLocationFlow'));
const AddLocationPlanChunk = React.lazy(() => import('./component/multiLocation/addLocation/AddLocationPlan'));
const AddLocationFlowHost = (props) => (
    <React.Suspense fallback={null}>
        <AddLocationFlowChunk {...props} />
    </React.Suspense>
);
const AddLocationPlanHost = (props) => (
    <React.Suspense fallback={null}>
        <AddLocationPlanChunk {...props} />
    </React.Suspense>
);
// Reception mode: adding a location is a payment (pay first, plan price), so
// it is hidden with Locations OR Billing (reception audit H9). The whole
// business's owner only (permissions).
const AddLocationFlowGuarded = requireCapability(ReceptionModeGuard(AddLocationFlowHost, ['locations', 'billing']), { groupOwner: true });
const AddLocationPlanGuarded = requireCapability(ReceptionModeGuard(AddLocationPlanHost, ['locations', 'billing']), { groupOwner: true });

export const history = createBrowserHistory();
installNavTrail(history);

// Old booking-flow URL → the current booking page for the same salon, and
// the same stylist when the link named one ('any' meant no preference).
const legacyBookingTarget = (base, hairdresserId, location) => ({
    pathname: hairdresserId && hairdresserId !== 'any' ? `${base}/professional/${hairdresserId}` : base,
    search: location.search,
});

/* Route changes start at the top of the page. An SPA keeps the previous
   page's scroll position by default, so a page opened from a scrolled list
   appeared mid-page. Back/forward (POP) is left alone, so returning to a
   list keeps the browser's own behaviour rather than yanking to the top. */
// Sheets that open over a list (the client's booking details) keep the page
// where it was: the list underneath must not jump to the top.
const SHEET_ROUTES = [/^\/dashboard\/bookings\/[^/]+$/];
const isSheetRoute = (pathname) => SHEET_ROUTES.some((re) => re.test(pathname));

class ScrollToTopOnNavigate extends Component {
  componentDidMount() {
    this.unlisten = history.listen((location, action) => {
      if (action === 'POP') return;
      if (isSheetRoute(location.pathname) || isSheetRoute(this.lastPath || '')) { this.lastPath = location.pathname; return; }
      this.lastPath = location.pathname;
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }
  componentWillUnmount() { if (this.unlisten) this.unlisten(); }
  render() { return null; }
}

let {isLatestVersion, emptyCacheStorage} = ClearCache

// Hoisted to module scope so its identity is STABLE across Routes re-renders.
// ReceptionModeGuard builds a NEW class per call, so an inline
// `component={ReceptionModeGuard(Clients,'clients')}` would hand <Route> a fresh
// component type on every render and remount the list. The Clients list + its
// deep-linkable detail panel share one guarded component (see /clients route).
const ClientsGuarded = ReceptionModeGuard(Clients, 'clients');
const FinanceTransactionsGuarded = ReceptionModeGuard(Finance, 'transactions');
// Reception audit 2026-10-02: routes that had no guard, or the wrong area.
const CashupGuarded = ReceptionModeGuard(Cashup, ['cashup']);
const CashupDetailGuarded = ReceptionModeGuard(CashupDetail, ['cashup']);
const GiftCardsGuarded = ReceptionModeGuard(GiftCardsV2, ['catalogue', 'giftcards']);
const BillingGuarded = ReceptionModeGuard(Billing, ['settings', 'billing']);
const ReceptionInboxGuarded = ReceptionModeGuard(ReceptionInbox, ['aiReceptionist', 'clients', 'clientDetails']);
// Bailey: the whole tab can be hidden; its front desk / soul pages are the AI
// receptionist's (business numbers, conversations).
const AgentThreadGuarded = ReceptionModeGuard(AgentThread, ['bailey']);
const AgentFrontDeskGuarded = ReceptionModeGuard(AgentThread, ['bailey', 'aiReceptionist']);
const AgentThreadRoute = (props) => {
    const page = props.match && props.match.params && props.match.params.page;
    return page === 'front-desk' || page === 'soul' ? <AgentFrontDeskGuarded {...props} /> : <AgentThreadGuarded {...props} />;
};
// The Campaign Studio: one guarded component for /new, /new/:source and /:id,
// so a new campaign's first save moving it to its own address doesn't remount it
const CampaignStudioGuarded = requireCapability(ReceptionModeGuard(CampaignStudioPage, 'marketing'), { any: ['marketing'], selfEmployed: true });
// Signup-funnel switch (was a weekend fraud stopgap, 2026-06-20). FALSE = the
// hardened in-app v2 signup wizard (SMS 2FA + merchantStatus='pending' gate) is
// live at /signup/professional. TRUE = fall back to the booked-demo redirect
// (Calendly) — kept as an emergency kill-switch if we ever need to halt
// self-serve merchant signups again. Real fraud control is now the per-owner
// merchantStatus approval gate, not this blanket redirect.
const REDIRECT_PROFESSIONAL_SIGNUP = false;
const PROFESSIONAL_SIGNUP_REDIRECT_URL = 'https://calendly.com/benfrombeu/beu-demo';

class ProfessionalSignupRedirect extends Component {
  componentDidMount() {
    window.location.replace(PROFESSIONAL_SIGNUP_REDIRECT_URL);
  }
  render() { return null; }
}

class Routes extends Component {
  // ─── Feature flags ───
  ENABLE_UNIVERSAL_SEARCH = true; // Cmd+K search — re-enabled now clients are migrated (search is storage-aware)

  constructor(props) {
    super(props);
    const { dispatch } = this.props;
    history.listen((location, action) => {
         
      
    });
    this.navigateRef = React.createRef();
  
  }


componentDidMount(){
  // console.log("dfdfdfuhikkk",this.navigateRef.current.className,history.location.pathname)

  if(this.navigateRef?.current?.className=='native-platform'){
    document.body.classList.add('native-platform-modal')
    // Kill the WebKit rubber-band in the app: overscroll-behavior only works
    // on the root scroller, so html and body get stamped directly.
    document.documentElement.classList.add('native-platform-doc')
    document.body.classList.add('native-platform-doc')
  }
  // console.log("ttttttt",this.props)

  // Refresh the user profile on app boot. redux-persist rehydrates state.user
  // from localStorage, which can be days/weeks stale — predating fields that
  // were added later (e.g. isSalonOwner, employmentTypeId roll-ups). Result:
  // components reading state.user.userInfo.* render with stale data until the
  // next manual trigger (login, profile switch). Dispatching userActions.profile
  // once here gives Redux a current server-truth user object on every cold start.
  // Gated on accessToken so we don't poke /profile for logged-out visitors.
  if (localStorage.getItem('accessToken')) {
    const params = { defaultRedirectTo: localStorage.getItem('defaultRedirectTo') };
    this.props.dispatch(userActions.profile(params)).catch(() => { /* silent */ });
    // Roles & permissions: what this person can do at the active location.
    // Silent — until it lands (or if it fails) gates use their account type.
    loadAccess();
  }

  // Subscription gate feed. Refresh {requiresSubscription, subscriptionStatus}
  // on every cold start so PrivateRoute can block a flagged, unsubscribed NEW
  // signup and route them to checkout. FAIL-OPEN: any error leaves the gate
  // untouched — existing salons are never flagged, so they are never gated.
  if (localStorage.getItem('accessToken')) {
    userService.getSubscriptionStatus()
      .then((res) => {
        const d = (res && res.data && res.data.responseData) || {};
        const requiresSubscription = d.requiresSubscription === true;
        const subscriptionStatus = d.subscriptionStatus || null;
        // Unix seconds — when the trial/current period ends. The SideNav trial
        // badge derives "N days left" from this.
        const subscriptionCurrentPeriodEnd = d.subscriptionCurrentPeriodEnd || null;
        localStorage.setItem('subscriptionGate', JSON.stringify({ requiresSubscription, subscriptionStatus, subscriptionCurrentPeriodEnd }));
        const blocked = requiresSubscription && subscriptionStatus !== 'trialing' && subscriptionStatus !== 'active';
        if (blocked && history.location.pathname !== '/subscription-checkout') {
          history.push('/subscription-checkout');
        }
      })
      .catch(() => { /* fail-open: leave the gate as-is */ });
  }

  // Partner Terms gate feed. Self-employed professionals must accept the
  // CURRENT published Partner Terms before using the app; the server says
  // whether this account still needs to (fail-open on any error). Refreshed
  // every cold start so publishing a new version re-prompts everyone.
  // PrivateRoute redirects to /welcome/partner-terms while the flag is set;
  // the welcome page clears it on accept. Salon owners and employed staff
  // are never flagged (server-side rule) so they never see the page.
  if (localStorage.getItem('accessToken')) {
    userService.getPartnerTermsStatus()
      .then((res) => {
        const d = (res && res.data && res.data.responseData) || {};
        const requiresAcceptance = d.requiresAcceptance === true;
        localStorage.setItem('partnerTermsGate', JSON.stringify({
          requiresAcceptance,
          currentVersion: d.currentVersion || null,
        }));
        if (requiresAcceptance && history.location.pathname !== '/welcome/partner-terms') {
          history.push({ pathname: '/welcome/partner-terms', state: { from: history.location } });
        }
      })
      .catch(() => { /* fail-open: leave the gate as-is */ });
  }

  // Android hardware back button: walk the router history rather than closing
  // the app on every press. On iOS the equivalent UX is the edge-swipe gesture
  // enabled in MainViewController.swift - no JS hook needed there. Skipped on
  // web where the browser handles the back button itself.
  if (Capacitor.isNativePlatform()) {
    import('@capacitor/app').then(({ App }) => {
      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack || window.history.length > 1) {
          window.history.back();
        } else {
          App.exitApp();
        }
      }).then((listener) => {
        this._backButtonListener = listener;
      });
    }).catch(() => {
      // Plugin not registered in the native shell yet (pre-rebuild). Silent.
    });
  }
}

componentWillUnmount() {
  if (this._backButtonListener) {
    this._backButtonListener.remove();
    this._backButtonListener = null;
  }
}

  render() {
    
    let accessToken = localStorage.getItem('accessToken');
    //console.log("######accessToken######",accessToken);
      if(accessToken && accessToken!=="") {
          //axios.defaults.headers.common['Authorization'] = `${'Bearer ' + accessToken}`;
      }
 // console.log("##$$", Capacitor.isNativePlatform());

    return (
        <Router history={history}>
          <OnboardingProvider>
          <SetupProvider>
           <ScrollToTopOnNavigate />
           {this.ENABLE_UNIVERSAL_SEARCH && <UniversalSearch />}
           <div ref={this.navigateRef} className={Capacitor.isNativePlatform()===true?'native-platform' : ''}>
          
            <ClearCache auto={true}>
            {({ isLatestVersion}) => (
            <>
            {console.log( "isLatestVersion # ",isLatestVersion,localStorage.getItem('APP_VERSION'))}
          <WebHeader history={history}/>
          <div className="fade modal-backdrop showw" style={{pointerEvents:'none'}}></div>
          <div className="bodyContainer ">
            {/* SideNav rendered once here so it never unmounts/remounts on route change.
                It returns null on public/auth/marketing-site routes (see PUBLIC_PATH_PREFIXES). */}
            <SideNav />
            <Switch>
                {/* New Auth Routes */}
                <Route exact path="/login" component={Login} />
                <Route exact path="/signup" component={SignupRoleSelector} />
                <Route exact path="/signup/client" component={ClientSignup} />
                <Route exact path="/signup/professional" component={REDIRECT_PROFESSIONAL_SIGNUP ? ProfessionalSignupRedirect : ProfessionalSignup} />
                {/* Gate destination: a logged-in but unsubscribed new signup lands here to finish subscribing. Plain Route (not PrivateRoute) to avoid a redirect loop. */}
                <Route exact path="/subscription-checkout" component={SubscriptionCheckout} />
                {/* Partner Terms gate for self-employed professionals. Plain Route
                    (not PrivateRoute) so the gate can't redirect to itself; the
                    page checks its own token. */}
                <Route exact path="/welcome/partner-terms" component={PartnerTermsWelcome} />
                <Route exact path="/forgot-password" component={ForgotPassword} />
                {/* Dev-only: review the onboarding / import layer against the mock adapter. */}
                {process.env.NODE_ENV !== 'production' && <Route exact path="/dev/onboarding" component={OnboardingPreview} />}
                <Route exact path="/forms/fill/:formId" component={FormFill} />
                
                {/* Legacy Routes */}
                <Route exact path="/" component={Homepage}  key={1} />
                <Route path="/social-login" component={Homepage}/>
                <Route path="/redirect" component={AppleRedirect}/>
                <Route path="/reset/:token" component={ResetPassword} />
                <Route path="/magic/:token" component={require('./component/auth/MagicLinkLanding').default} />
                {/*<Route exact path="/salon/:salonId" component={HairdresserComponent} />*/}
                {/*<Route exact path="/old-salon/:salonId/professional/:hairdresserId" component={HairdresserComponent} />*/}
                {/*<Route exact path="/old-salon/:salonId/professional/:hairdresserId/success" component={HairdresserComponent} />*/}
                {/*<Route exact path="/old-salon/:salonId/professional/:hairdresserId/fail" component={HairdresserComponent} />*/}
                {/* Gift-card claim (email / deep link) — binds a code to the
                    signed-in user's wallet, then lets them choose the design. */}
                <Route exact path="/gift-cards/claim/:code" component={ClaimGiftCard} />
                {/* Front-end preview/spec of the recipient's gift-card email. */}
                <Route exact path="/gift-cards/email-preview" component={GiftCardEmailPreview} />

                {/* A professional's own branded booking link. Declared BEFORE
                    the /book/:salonSlug routes: /book/pro/:x is three segments
                    and can't currently be shadowed by any of them, but ordering
                    it first makes that true by construction rather than by
                    luck, so a future /book/:salonSlug/:anything can't capture
                    it. ('pro' is also in the backend's reserved-slug blocklist,
                    so no salon can ever claim it.)

                    The param is deliberately named :hairdresserId (not
                    :proSlug) so SalonProfilePage's existing professional branch
                    picks it up unchanged — the backend resolves a bare pro slug
                    globally, and returns nothing rather than guessing if it is
                    ambiguous.

                    ADDITIVE ONLY: /book/:salonSlug/professional/:hairdresserId
                    keeps working exactly as before, forever. Every link Beu has
                    ever issued must keep resolving. */}
                <Route exact path="/book/pro/:hairdresserId" component={SalonProfilePage} />
                <Route exact path="/book/pro/:hairdresserId/success" component={BookingConfirmationPage} />
                <Route exact path="/book/pro/:hairdresserId/fail" component={SalonProfilePage} />

                {/* SEO-friendly /book/ routes (slug-based) */}
                <Route exact path="/book/:salonSlug" component={SalonProfilePage} />
                <Route exact path="/book/:salonSlug/gift-cards" component={GiftCardShop} />
                <Route exact path="/book/:salonSlug/gift-cards/success" component={GiftCardConfirmation} />
                <Route exact path="/book/:salonSlug/shop" component={ProductShop} />
                {/* The old staff → service → booking-slot flow still booked
                    through the legacy backend. Old saved links (bios, bookmarks)
                    kept landing people in it, so send them to the current
                    booking page instead. */}
                <Route exact path="/book/:salonSlug/staff" render={({ match, location }) => <Redirect to={legacyBookingTarget('/book/' + match.params.salonSlug, null, location)} />} />
                <Route exact path="/book/:salonSlug/:hairdresserId/(service|booking-slot)" render={({ match, location }) => <Redirect to={legacyBookingTarget('/book/' + match.params.salonSlug, match.params.hairdresserId, location)} />} />
                <Route exact path="/book/:salonSlug/professional/:hairdresserId" component={SalonProfilePage} />
                <Route exact path="/book/:salonSlug/professional/:hairdresserId/success" component={BookingConfirmationPage} />
                <Route exact path="/book/:salonSlug/professional/:hairdresserId/fail" component={SalonProfilePage} />

                {/* Earlier shape of the same link, kept permanently. It only ever
                    reached staging, but the whole point of these URLs is that
                    people paste them places we can't see — so it redirects
                    rather than 404s. Costs one line. */}
                <Route
                    exact
                    path="/pro/:hairdresserId"
                    render={({ match }) => <Redirect to={`/book/pro/${match.params.hairdresserId}`} />}
                />
                <Route
                    exact
                    path="/pro/:hairdresserId/:tail"
                    render={({ match }) => (
                        <Redirect to={`/book/pro/${match.params.hairdresserId}/${match.params.tail}`} />
                    )}
                />

                {/* Online product order — post-Stripe-checkout landing */}
                <Route exact path="/store/order/:orderId" component={ProductOrderSuccess} />

                {/* Category + Location landing pages */}
                <Route exact path="/hair-salons/in/:location" component={CategoryLocationPage} />
                <Route exact path="/barbers/in/:location" component={CategoryLocationPage} />
                <Route exact path="/beauty-salons/in/:location" component={CategoryLocationPage} />
                <Route exact path="/nail-salons/in/:location" component={CategoryLocationPage} />
                <Route exact path="/spas/in/:location" component={CategoryLocationPage} />

                {/* Legacy /salon/ routes (backward compat — redirects to /book/ in SalonProfilePage) */}
                <Route exact path="/salon/:salonId" component={SalonProfilePage} />
                <Route exact path="/salon/:salonId/gift-cards" component={GiftCardShop} />
                <Route exact path="/salon/:salonId/gift-cards/success" component={GiftCardConfirmation} />
                <Route exact path="/salon/:salonId/shop" component={ProductShop} />
                <Route exact path="/salon/:salonId/staff" render={({ match, location }) => <Redirect to={legacyBookingTarget('/salon/' + match.params.salonId, null, location)} />} />
                <Route exact path="/salon/:salonId/:hairdresserId/(service|booking-slot)" render={({ match, location }) => <Redirect to={legacyBookingTarget('/salon/' + match.params.salonId, match.params.hairdresserId, location)} />} />
                <Route exact path="/salon/:salonId/professional/:hairdresserId" component={SalonProfilePage} />
                <Route exact path="/salon/:salonId/professional/:hairdresserId/success" component={BookingConfirmationPage} />
                <Route exact path="/salon/:salonId/professional/:hairdresserId/fail" component={SalonProfilePage} />

                {/*<Route exact path="/diary-old/:salonId" component={DiaryPage} />*/}
                {/* The pre-DiaryV2 diary ran on the legacy v1 backend. */}
                <Route exact path="/diary-legacy/:salonId" render={({ match }) => <Redirect to={`/diary/${match.params.salonId}`} />} />
                {/* All four diary URL shapes go through ONE Route element so
                    DiaryV2 stays mounted as the deep-link tail changes. If
                    we used four separate Routes the Switch would pick a
                    different element on every booking click → DiaryV2 would
                    unmount/remount, refetch, and the URL-sync would loop. */}
                <Route
                  exact
                  path={[
                    "/diary/:salonId",
                    "/diary/:salonId/booking/:bookingId",
                    "/diary/:salonId/event/:eventId",
                    "/diary/:salonId/leave/:leaveId",
                  ]}
                  component={ReceptionModeGuard(DiaryV2, 'diary')}
                />
                {/* <Route exact path="/diary/:salonId" render={()=>(<NewDiary hi="clsname"/>)} /> */}
              {/*<Route exact path="/diary1/:salonId" component={DiaryResource} />*/}
              {/*<Route exact path="/newdiary1/:salonId" component={NewDiary1} />*/}
                <Route exact path="/event/:salonId" component={NewEvent} />
                <Route exact path="/leave/:salonId" component={Leave} />
                <Route exact path="/cashup" component={CashupGuarded} />
                <Route exact path="/cashup/detail/:cashupId" component={CashupDetailGuarded} />
                <Route exact path="/stocktake" component={requireCapability(ReceptionModeGuard(Stocktake, ['catalogue', 'stocktake']), { any: ['products'] })} />
                <Route exact path="/stocktake/new" component={requireCapability(ReceptionModeGuard(NewStocktake, ['catalogue', 'stocktake']), { any: ['products'] })} />
                <Route exact path="/stocktake/:stocktakeId" component={requireCapability(ReceptionModeGuard(StocktakeDetail, ['catalogue', 'stocktake']), { any: ['products'] })} />
                <Route exact path="/stock-transfers" component={requireCapability(ReceptionModeGuard(StockTransfersPage, ['catalogue', 'stocktake']), { owner: true })} />
                <Route exact path="/catalogue" component={requireCapability(ReceptionModeGuard(CatalogueOverview, 'catalogue'), { any: ['catalogue'], selfEmployed: true })} />
                <Route exact path="/forms" component={requireCapability(ReceptionModeGuard(Forms, ['catalogue', 'forms']), { any: ['services'] })} />
                <Route exact path="/forms/new" component={requireCapability(ReceptionModeGuard(NewForm, ['catalogue', 'forms']), { any: ['services'] })} />
                <Route exact path="/forms/settings" component={requireCapability(ReceptionModeGuard(FormSettings, ['catalogue', 'forms']), { any: ['services'] })} />
                <Route exact path="/forms/submission/:submissionId" component={ReceptionModeGuard(FormSubmissionView, ['catalogue', 'forms'])} />
                <Route exact path="/forms/complete/:submissionId" component={ReceptionModeGuard(FormComplete, ['catalogue', 'forms'])} />
                {/* The V2 gift-card module is the one and only Vouchers area.
                    Legacy voucher pages are retired; their URLs redirect so old
                    bookmarks/deep-links keep working. */}
                <Route exact path="/voucher-v2" component={requireCapability(GiftCardsGuarded, { any: ['gift_cards'] })} />
                <Redirect exact from="/voucher" to="/voucher-v2" />
                <Redirect exact from="/voucher-setup" to="/voucher-v2" />
                <Redirect exact from="/voucher-sales" to="/voucher-v2" />
                {/* The old full-page New Booking ran on the legacy v1 backend;
                    the diary's New Booking sidebar replaced it. */}
                <Route exact path="/newbooking/:salonId" component={NewBookingRedirect} />
                <Route exact path="/newbooking/:salonId/:hairdresserId" component={NewBookingRedirect} />
                {/*<Route exact path="/old-booking/:salonId" component={NewBooking} />*/}
                {/*<Route exact path="/old-booking/:salonId/:hairdresserId" component={NewBooking} />*/}
                <Route exact path="/new-checkout/:salonId" component={ReceptionModeGuard(InstantCheckout, 'checkout')} />
                <Route exact path="/pos" component={ReceptionModeGuard(POSPage, 'checkout')} />
                <Route exact path="/clients-nav" component={ReceptionModeGuard(ClientsMobileNav, 'clients')} />
                <Route exact path="/clients/data-sharing" component={ReceptionModeGuard(DataSharing, 'clients')} />
                <Route exact path="/clients/ownership" component={ReceptionModeGuard(Ownership, 'clients')} />
                <Route exact path="/clients/export-import" component={ReceptionModeGuard(ExportImport, ['clients', 'importExport'])} />
                <Route exact path="/clients/add" component={ReceptionModeGuard(AddClient, 'clients')} />
                <Route exact path="/clients/booking/add" component={ReceptionModeGuard(AddClient, 'clients')} />
                {/* ONE Route for both the list and its deep-linkable detail panel.
                    /clients and /clients/:id share a single Route element + a single
                    (hoisted) guarded component, so opening a client via
                    history.push('/clients/:id') UPDATES this route (panel opens via
                    componentDidUpdate) instead of unmounting/remounting the list —
                    which was wiping the search + flickering the table. Sits AFTER the
                    specific /clients/* sub-routes so Switch matches those first. */}
                <Route exact path={["/clients", "/clients/:id"]} component={ClientsGuarded} />
                <Route exact path="/clients/edit/:id" component={ReceptionModeGuard(EditClient, 'clients')} />
                {/* One route, optional id: two routes each wrapped Finance in a fresh guard class,
                    so opening a transaction remounted the page and dropped every filter. */}
                <Route exact path="/transactions/:transactionId?" component={requireCapability(FinanceTransactionsGuarded, { any: ['reports'], selfEmployed: true })} />
                <Redirect exact from="/legacy-transactions" to="/transactions" />
                <Route exact path="/finance" component={requireCapability(ReceptionModeGuard(Finance, 'transactions'), { any: ['reports'], selfEmployed: true })} />
                <Route exact path="/finance-nav" component={requireCapability(ReceptionModeGuard(FinanceMobileNav, 'transactions'), { any: ['reports'], selfEmployed: true })} />
                <Route exact path="/staff" component={ReceptionModeGuard(Staff, 'staff')} />
                <Route exact path="/staff-nav" component={ReceptionModeGuard(StaffMobileNav, 'staff')} />
                <Route exact path="/staff/members" component={ReceptionModeGuard(Staff, ['staff', 'teamMembers'])} />
                <Route exact path="/staff/schedules" component={ReceptionModeGuard(Staff, ['staff', 'schedules'])} />
                <Route exact path="/staff/staff-pay" component={requireCapability(ReceptionModeGuard(Staff, ['staff', 'staffPay']), { any: ['team'] })} />
                <Route exact path="/staff/permissions" component={ReceptionModeGuard(Staff, 'staff')} />
                <Route exact path="/staff/rota" component={ReceptionModeGuard(Staff, ['staff', 'schedules'])} />
                <Route exact path="/staff/add" component={requireCapability(ReceptionModeGuard(AddStaff, ['staff', 'teamMembers']), { any: ['team'] })} />
                <Route exact path="/staff/:id" component={ReceptionModeGuard(EditStaff, ['staff', 'teamMembers'])} />
                {/* The old per-stylist services pages ran on the legacy v1 backend. */}
                <Redirect exact from="/services" to="/new-services" />


                <Route exact path="/new-services" component={ReceptionModeGuard(NewServices, ['catalogue', 'services'])} />
                <Route exact path="/add-services" component={ReceptionModeGuard(AddServices, ['catalogue', 'services'])} />
                <Route exact path="/edit-services/:id" component={ReceptionModeGuard(EditServices, ['catalogue', 'services'])} />
                <Route exact path="/service-nav" component={requireCapability(ReceptionModeGuard(ServiceMobileView, ['catalogue']), { any: ['catalogue'], selfEmployed: true })} />
                
                <Route exact path="/marketing" component={requireCapability(ReceptionModeGuard(Marketing, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-nav" component={requireCapability(ReceptionModeGuard(MarketingMobileView, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-setting" component={requireCapability(ReceptionModeGuard(MarketingSettings, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-brand" component={requireCapability(ReceptionModeGuard(MarketingBrand, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-campaigns" component={requireCapability(ReceptionModeGuard(MarketingCampaigns, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path={["/marketing-campaigns/new/:source?", "/marketing-campaigns/:id"]} component={CampaignStudioGuarded} />
                <Route exact path="/marketing-performance" component={requireCapability(ReceptionModeGuard(MarketingPerformance, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-journeys" component={requireCapability(ReceptionModeGuard(MarketingJourneys, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-social" component={requireCapability(ReceptionModeGuard(MarketingSocial, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-home" component={requireCapability(ReceptionModeGuard(MarketingHome, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                <Route exact path="/marketing-calendar" component={requireCapability(ReceptionModeGuard(MarketingCalendarPage, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                {/* Beu agent. AGENT_VISIBLE is the outermost of three switches
                    (BE AGENT_ENABLED, then per-principal opt-in), so the route
                    simply does not exist off staging. NOT wrapped in a
                    ReceptionModeGuard area per tool: reception mode gates the
                    agent per TOOL on the backend. The tab itself is the `bailey`
                    area; its front desk / soul pages are the AI receptionist's. */}
                {AGENT_VISIBLE && <Route exact path="/assistant/:page(front-desk|soul)?/:step(setup|conversations)?" component={AgentThreadRoute} />}
                {MESSAGES_VISIBLE && <Route exact path="/messages/:space(team|clients|support)?/:chatId?" component={MessagesHost} />}
                {TAXES_VISIBLE && <Route exact path="/taxes" component={requireCapability(ReceptionModeGuard(TaxesPage, ['catalogue', 'taxes']), { any: ['settings', 'services'], selfEmployed: true })} />}
                <Route exact path="/marketing-loyalty" component={requireCapability(ReceptionModeGuard(LoyaltyPage, 'marketing'), { any: ['marketing'], selfEmployed: true })} />
                {/* Discount codes: the salon's (owner, or a role with the server's
                    discount_codes capability once it exists) and a self-employed
                    stylist's own. Not on beta/prod yet (DISCOUNTS_VISIBLE). */}
                {DISCOUNTS_VISIBLE && <Route exact path="/marketing-discounts" component={requireCapability(ReceptionModeGuard(DiscountsPage, 'marketing'), { any: ['discount_codes'], selfEmployed: true })} />}
                <Route exact path="/settings/billing" component={requireCapability(BillingGuarded, { owner: true, selfEmployed: true })} />
                {/* Pricing (Oct 2026): Plan & usage is now part of Billing ("Plan & billing"). */}
                {PRICING_V2_VISIBLE && <Redirect exact from="/settings/plan-usage" to="/settings/billing" />}
                <Route exact path="/settings/diary-sharing" component={requireCapability(ReceptionModeGuard(DiarySharePage, ['settings', 'diarySharing']), { any: ['settings'], selfEmployed: true })} />
                
                <Redirect exact from="/services/:hairdresserId" to="/new-services" />
                <Redirect exact from="/services/:hairdresserId/:serviceId" to="/new-services" />
                
                {/* Settings routes with SettingsWrapper and SettingsRedirect */}
                <Route exact path="/settings" component={ReceptionModeGuard(SettingMobileView, 'settings')} />
                <Route exact path="/settings/salon-details" component={requireCapability(ReceptionModeGuard(SalonSettings, ['settings', 'salonDetails']), { any: ['settings'] })} />
                <Route exact path="/settings/booking-url" component={requireCapability(ReceptionModeGuard(BookingUrl, ['settings', 'bookingUrl']), { any: ['settings'], selfEmployed: true })} />
                <Route exact path="/settings/edit-password" component={ReceptionModeGuard(EditPassword, ['settings', 'accountPassword'])} />
                <Route exact path="/settings/import-data" component={requireCapability(ReceptionModeGuard(ImportData, ['settings', 'importExport']), { any: ['settings'], selfEmployed: true })} />
                <Route exact path="/settings/finish-setup" component={requireCapability(ReceptionModeGuard(FinishSetupSettings, ['settings', 'finishSetup']), { owner: true, selfEmployed: true })} />
                {ONBOARDING_DEMO_VISIBLE && <Route exact path="/settings/onboarding" component={requireCapability(ReceptionModeGuard(OnboardingSettings, ['settings', 'finishSetup']), { owner: true })} />}
                {ONBOARDING_DEMO_VISIBLE && <Route exact path="/settings/diary-demo" component={requireCapability(ReceptionModeGuard(DiaryDemoSettings, ['settings', 'finishSetup']), { owner: true })} />}
                {SAVINGS_CALCULATOR_VISIBLE && <Route exact path="/settings/savings-calculator" component={requireCapability(ReceptionModeGuard(SavingsCalculatorHost, ['settings', 'finishSetup']), { owner: true })} />}
                {ONBOARDING_DEMO_VISIBLE && <Route exact path="/settings/bailey-welcome" component={BaileyWelcomeReplay} />}
                <Route exact path="/settings/edit-bank-account" component={requireCapability(ReceptionModeGuard(EditBankAccount, ['settings', 'payoutAccount']), { owner: true, selfEmployed: true })} />
                <Redirect exact from="/settings/profile" to="/staff" />
                <Route exact path="/settings/add-payout-account" component={requireCapability(ReceptionModeGuard(AddPayoutAccount, ['settings', 'payoutAccount']), { owner: true, selfEmployed: true })} />
                <Redirect exact from="/settings/account-password" to="/staff" />
                <Route exact path="/settings/payout-account" component={requireCapability(ReceptionModeGuard(PayoutAccount, ['settings', 'payoutAccount']), { owner: true, selfEmployed: true })} />
                <Route exact path="/settings/card-reader" component={requireCapability(ReceptionModeGuard(CardReader, ['settings', 'cardReader']), { any: ['settings'], selfEmployed: true })} />
                <Route exact path="/settings/notifications" component={ReceptionModeGuard(NotificationSettings, ['settings', 'notificationSettings'])} />
                {/* A self-employed stylist's own choices (the page tells anyone else where to look). */}
                <Route exact path="/settings/your-choices" component={requireCapability(ReceptionModeGuard(YourChoices, 'settings'), { selfEmployed: true })} />
                <Route exact path="/settings/reception-mode" component={requireCapability(ReceptionModeGuard(ReceptionMode, 'settings'), { any: ['settings'] })} />
                {/* The AI receptionist: behind its launch flag like the inbox (a typed
                    URL must not open it where it isn't live), and for whoever has
                    `settings` — not every self-employed stylist (audit 2026-09-29).
                    With the Bailey tab on it opens Bailey's front desk. */}
                {/* A location's phone numbers and their jobs (calls, two-way texts). */}
                {CONCIERGE_VISIBLE && <Route exact path="/settings/business-numbers" component={requireCapability(ReceptionModeGuard(BusinessNumbers, ['settings', 'aiReceptionist']), { any: ['settings'] })} />}
                {CONCIERGE_VISIBLE && <Route exact path="/settings/ai-assistant" component={requireCapability(ReceptionModeGuard(AGENT_VISIBLE ? FrontDeskRedirect : AiAssistant, ['settings', 'aiReceptionist']), { any: ['settings'] })} />}
                {/* Bailey's inbox: every receptionist conversation, and stepping in. */}
                {CONCIERGE_VISIBLE && <Route exact path="/receptionist" component={requireCapability(ReceptionInboxGuarded, { any: ['settings'] })} />}
                <Route exact path="/settings/locations" component={requireCapability(ReceptionModeGuard(LocationsPage, ['settings', 'locations']), { groupOwner: true })} />
                <Route exact path="/add-location" component={AddLocationFlowGuarded} />
                <Route exact path="/add-location/plan" component={AddLocationPlanGuarded} />
                <Route exact path="/event" component={Event} />
                {/*<Route exact path="/join" component={JoinForFree} />*/}
                {/* /event-view/:eventId, /leave-view/:holidayId and
                    /booking/:bookingId (below) were legacy "view full"
                    screens reachable from BookingDetailPanel. Routes
                    removed so the URLs 404; the menu option is gone too. */}
                <Route exact path="/steps" component={Steps} />
                <Route exact path="/steps-after-login" component={GoThroughModalAfterLogin} />
                {/*<Route exact path="/hairdressers-home" component={HairdressersHome}/>*/}

                {/*<PrivateRoute path='/booking/:bookingId' component={Booking} />*/}
                {/*<PrivateRoute path='/booking-edit/:bookingId' component={EditBooking} />*/}
                <PrivateRoute path='/new-booking-edit/:bookingId' component={BookingInDiaryRedirect} />
                
                {/* <PrivateRoute path='/booking-checkout/:bookingId' component={checkoutBooking} /> */}
                <PrivateRoute path='/checkout/:bookingId' component={BookingInDiaryRedirect} />
                <PrivateRoute path='/select-client/:hairdresserId/:indexId' component={SelectClient} />
                {/* <PrivateRoute path='/product/BookingCheckout/:bookingId' component={BookingCheckout} /> */}

                <PrivateRoute path='/invoice/:bookingId' component={BookingInvoice} />
                
                {/* New Client Dashboard Routes */}
                <PrivateRoute path='/dashboard' component={ClientDashboard} />
                
                {/* Admin Routes - Protected with random path segment for security */}
                <PrivateRoute path='/sales-x7k9' component={SalesModuleHost} />
                <PrivateRoute exact path='/beu-admin-x7k9/dashboard' component={AdminDashboard} />
                <PrivateRoute exact path='/beu-admin-x7k9/users' component={AdminUsers} />
                <PrivateRoute exact path='/beu-admin-x7k9/users/:id' component={AdminUserDetail} />
                <PrivateRoute exact path='/beu-admin-x7k9/professionals' component={AdminProfessionals} />
                <PrivateRoute exact path='/beu-admin-x7k9/professionals/:id' component={AdminProfessionalDetail} />
                <PrivateRoute exact path='/beu-admin-x7k9/businesses' component={AdminBusinesses} />
                <PrivateRoute exact path='/beu-admin-x7k9/businesses/:id' component={AdminBusinessDetail} />
                <PrivateRoute exact path='/beu-admin-x7k9/bookings' component={AdminBookings} />
                <PrivateRoute exact path='/beu-admin-x7k9/bookings/:id' component={AdminBookingDetail} />
                <PrivateRoute exact path='/beu-admin-x7k9/financials' component={AdminFinancials} />
                <PrivateRoute exact path='/beu-admin-x7k9/reconciliations' component={AdminReconciliations} />
                <PrivateRoute exact path='/beu-admin-x7k9/payment-bible' component={AdminPaymentBible} />
                <PrivateRoute exact path='/beu-admin-x7k9/policies' component={AdminPolicies} />
                <PrivateRoute exact path='/beu-admin-x7k9/deals' component={AdminDeals} />
                <PrivateRoute exact path='/beu-admin-x7k9/merchant-approvals' component={AdminMerchantApprovals} />
                <PrivateRoute exact path='/beu-admin-x7k9/bailey' component={Bailey} />
                <PrivateRoute exact path='/beu-admin-x7k9/ai' component={AdminAiOverview} />
                {MESSAGES_VISIBLE && <PrivateRoute exact path='/beu-admin-x7k9/support' component={AdminSupportDesk} />}
                <PrivateRoute exact path='/beu-admin-x7k9/ai/salon/:salonId' component={AdminAiSalon} />
                <PrivateRoute exact path='/beu-admin-x7k9/ai/session/:kind/:id' component={AdminAiSession} />
                
                {/* Legacy Client Routes (keeping for backward compatibility) */}
                {/*<PrivateRoute path='/review' component={Dashboard} />*/}
                {/* The first client dashboard ran on the legacy v1 backend;
                    /dashboard replaced it. */}
                <Redirect exact from='/booking' to='/dashboard/bookings' />
                <Redirect from='/booking-detail/:bookingId' to='/dashboard/bookings/:bookingId' />
                <Redirect from='/myaccount' to='/dashboard/account' />
                <Redirect from='/legal' to='/terms' />

                <Route path="/terms-and-conditions" component={ClientTermsPage}/>
                <Route path="/terms" component={ClientTermsPage}/>
                <Route path="/privacy-policy" component={PrivacyPolicyPage}/>
                <Route path="/privacy" component={PrivacyPolicyPage}/>
                {/* Rebranded to Partner Terms; old URL kept — it's printed in emails and receipts. */}
                <Route path="/hairdresser-terms-and-conditions" component={PartnerTermsPage}/>
                <Route path="/partner-terms" component={PartnerTermsPage}/>
                <Route path="/beu-pay-terms" component={BeuPayTermsPage}/>

                <Route exact path="/redirection/price/:id/plan/:id" component={Redirection}  />
                <Route exact path="/get-software" component={Home}  />
                <Route exact path="/payment" component={Payment}  />
                <Route exact path="/booking-payment-success" component={PaymentSuccess}  />


                <Route exact path="/product" component={requireCapability(ReceptionModeGuard(Product, ['catalogue', 'products']), { any: ['products'] })} />
                <Route exact path="/resources" component={requireCapability(ReceptionModeGuard(ResourcesPage, ['catalogue', 'resources']), { any: ['settings', 'services'] })} />
                <Route exact path="/product/addProduct" component={requireCapability(ReceptionModeGuard(AddProduct, ['catalogue', 'products']), { any: ['products'] })} />
                <Route exact path="/product/editProduct" component={requireCapability(ReceptionModeGuard(EditProduct, ['catalogue', 'products']), { any: ['products'] })} />
                <Route exact path="/product/viewProduct" component={requireCapability(ReceptionModeGuard(ViewProduct, ['catalogue', 'products']), { any: ['products'] })} />
                <Route exact path="/product/deleteProduct" component={requireCapability(ReceptionModeGuard(DeleteProduct, ['catalogue', 'products']), { any: ['products'] })} />
                <Route exact path="/product/list-product" component={requireCapability(ReceptionModeGuard(Product, ['catalogue', 'products']), { any: ['products'] })} />
                {/*<Route exact path="/product/productCheckout" component={ProductCheckout} />*/}
                <Route exact path="/selectProduct/:salonId/:indexId" component={SelectProduct} />
                <Route exact path="/SelectVoucher/:salonId/:indexId" component={SelectVoucher} />
                {/*<Route exact path="/selectService" component={SelectService} />*/}
                <Route exact path="/new-selectService/:hairdresserId/:indexId" component={NewSelectService} />
                <Route path='/coming-soon' component={ComingSoon}  />
                <Route path='/404' component={Pagenotfound}  />
                <Route path='*' component={Pagenotfound} status={404} />

            </Switch>
          </div>
          {/* Rendered at router level so it persists across route changes
              (otherwise it unmounts/remounts when switching between
              NewHomePage and ClientDashboard, causing a visible flicker).
              Visibility per route is handled inside the component. */}
          <MobileTabBar />
          {/* Client-side loyalty moment: celebrates a newly earned stamp the
              next time the customer opens the app. Router level so it fires
              wherever they land; the component gates itself to the customer
              routes and stays silent when there is nothing new. */}
          <StampEarnedCelebration />
          {/* Global NewBookingPanel host. Renders the panel (and its
              minimised pill) only when there's an active booking draft in
              the minimisedBooking redux slice — survives route changes
              and (via redux-persist) browser reload. */}
          <NewBookingHost />
          {/* Bailey the desk pet, after the welcome tour: draggable, and
              where he is left is remembered across pages and tabs. */}
          <BaileyPet />
          {/* AI onboarding / import layer host (ONBOARDING-IMPORT-PLAN.md).
              Router level so a running import outlives the layer and the
              diary FAB, checklist and Clients → Import open the same thing. */}
          <OnboardingHost />
          {/* Set up with Bailey: the guided, resumable setup and its pill.
              Staging and below for now (SETUP_V2_ENABLED). */}
          <SetupHost />
          {/* Persistent Stripe alert: shows on every app page for an owner or
              self-employed stylist while Stripe needs something. Gates itself. */}
          <StripeAlertHost />
          {/* Pricing: the Bailey Plus modal (any CTA opens it) and one light,
              dismissible alert for the balance or the receptionist. Gates itself. */}
          <PricingHost />
                    </>
                    )}
            </ClearCache>
            </div>
            </SetupProvider>
          </OnboardingProvider>
        </Router>
    );
  }
}


function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert
  };
}

const connectedApp = connect(mapStateToProps)(Routes);
export { connectedApp as Routes };





